/**
 * A chave carrega o perfil porque a resposta é por conta: sem ele, sair de uma
 * conta bloqueada e entrar em outra serviria `true` do cache e prenderia quem
 * acabou de entrar atrás da tela de bloqueio de outra pessoa (docs/04 §2, o
 * mesmo raciocínio de `platformAccessKeys`).
 */
export const accountAccessKeys = {
  all: ['account-access'] as const,
  /** "Minha conta está bloqueada?" — a RPC `my_access_state`. */
  state: (profileId: string) => [...accountAccessKeys.all, 'state', profileId] as const,
};
